import { render, staticRenderFns } from "./VueTypeaheadBootstrapListItem.vue?vue&type=template&id=478980fb&scoped=true"
import script from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
export * from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
import style0 from "./VueTypeaheadBootstrapListItem.vue?vue&type=style&index=0&id=478980fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478980fb",
  null
  
)

export default component.exports